export const coursesManagement = {
  name: "Gestão de Cursos |||| Gestão de Cursos",
  fields: {
    title: "Nome do Curso",
    isEnabled: "Distribuído",
    order: "Ordem",
    courseGroupsIds: "Grupos",
    externalCourseId: "Moodle ID",
    groupsCount: "Quantidade de Grupos",
  },
};

export const myCourses = {
  name: "Meus Cursos |||| Meus Cursos",
  fields: {
    id: "ID",
    title: "Nome do Curso",
  },
  buttons: {
    access: "Acessar Curso",
  },
  messages: {
    courseNotFound: "Curso não encontrado",
    accessError: "Erro ao acessar o curso",
  },
};
